import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

export const AppPreset = definePreset(Aura, {
  components: {
    tree: {
      root: { padding: '0.571rem 1rem' },
      node: { padding: '0.143rem' }
    },
    card: {
      body: { padding: '1rem', gap: '0' }
    },
    datatable: {
      headerCell: { padding: '0.25rem 0.5rem' },
      bodyCell: { padding: '0.25rem 0.5rem' }
    },
    togglebutton: {
      colorScheme: {
        light: {
          root: {
            checkedBackground: '#AFD3C8',
            checkedBorderColor: '#AFD3C8'
          },
          content: {
            checkedBackground: '#AFD3C8'
          }
        }
      }
    }
  }
});
